import React, { forwardRef } from 'react';
import clsx from 'clsx';

export const CardHeaderTitle = forwardRef(({ className, ...props }, ref) => (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <h3 {...props} ref={ref} className={clsx('card-label', className)} />
));

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    CardHeaderTitle.displayName = 'CardHeaderTitle';
}
